"use strict";

/**
 * Function to toggle password visibility on click
 * @returns {void}
 */
module.exports = function () {
    $(".password-form-show").on("click", function () {
        let $showHideBtn = $(this);
        let $pwInput = $showHideBtn.parent().find("input");

        if ($pwInput.attr("type") === "password") {
            $pwInput.attr("type", "text");
            $showHideBtn.text($showHideBtn.attr("data-hide"));
        } else {
            $pwInput.attr("type", "password");
            $showHideBtn.text($showHideBtn.attr("data-show"));
        }
    });
};
